import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Public Pages
import Home from '../pages/public/Home';
import ScanPage from '../pages/public/ScanPage';
import ScratchPage from '../pages/public/ScratchPage';
import RewardPage from '../pages/public/RewardPage';
import StampPage from '../pages/public/StampPage';

// Auth Pages
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';

// Super Admin Pages
import SuperAdminDashboard from '../pages/admin/SuperAdminDashboard';
import CreateShopOwner from '../pages/admin/CreateShopOwner';

// Shop Owner Pages
import Dashboard from '../pages/admin/Dashboard';
import Campaigns from '../pages/admin/Campaigns';
import CreateCampaign from '../pages/admin/CreateCampaign';
import Rewards from '../pages/admin/Rewards';
import Analytics from '../pages/admin/Analytics';
import Settings from '../pages/admin/Settings';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/scan" element={<ScanPage />} />
      <Route path="/scratch" element={<ScratchPage />} />
      <Route path="/reward" element={<RewardPage />} />
      <Route path="/stamp" element={<StampPage />} />

      {/* Auth Routes */}
      <Route path="/shopowner" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Super Admin Routes */}
      <Route path="/super-admin/dashboard" element={<SuperAdminDashboard />} />
      <Route path="/super-admin/create-shop" element={<CreateShopOwner />} />

      {/* Shop Owner Routes */}
      <Route path="/admin/dashboard" element={<Dashboard />} />
      <Route path="/admin/campaigns" element={<Campaigns />} />
      <Route path="/admin/create-campaign" element={<CreateCampaign />} />
      <Route path="/admin/rewards" element={<Rewards />} />
      <Route path="/admin/analytics" element={<Analytics />} />
      <Route path="/admin/settings" element={<Settings />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
